module.exports = __webpack_public_path__ + "img/pr-2.3dcbb0e1.png";